"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceSectionContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _Prices = require("../Prices");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Displays section with current, old, and previous lowest price, mpr statement, cashback and business points.
 */
const PriceSectionContent = ({
  className,
  currentPrice,
  cataloguePrice,
  priceAfterImmediateDiscount,
  customerTypeId,
  mrpStatementEnabled,
  size = 'medium'
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.PRICE_SECTION),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Prices.Prices, {
      currentPrice: currentPrice,
      cataloguePrice: cataloguePrice,
      priceAfterImmediateDiscount: priceAfterImmediateDiscount,
      customerTypeId: customerTypeId,
      mrpStatementEnabled: mrpStatementEnabled,
      size: size
    }), mrpStatementEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MprStatement, {
      "data-testid": getTestId(_constants.MPR_STATEMENT),
      children: translations.mrpStatement
    }) : null]
  });
};
exports.PriceSectionContent = PriceSectionContent;
//# sourceMappingURL=PriceSectionContent.js.map